// extracted by css-extract-rspack-plugin
export default {"list":"list-A5XAbR","emptyState":"emptyState-s_i9Fk","item":"item-AUAhKO","number":"number-QEc_k8","title":"title-PE1Tvk","description":"description-vdgS1R","tags":"tags-PqX1Vq"};